var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegisteredUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#1C2154"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1167 -215) translate(1167 215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11,
    r: 7.677,
    strokeWidth: 2.646
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M22.135 42.64H7.985c-2.21 0-4.001-1.791-4.001-4.001 0 0 0 0 0 0 0-9.94 6.638-17.998 14.826-17.998 3.479 0 6.677 1.454 9.206 3.889"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7.414 13.467l-.034-.03c-.41-.353-1.047-.55-1.878-.56H1.04l-.034-.001c-.547-.018-.988-.464-1.005-1.02L0 11.823V1.02C.019.465.459.02 1.006 0h4.481C7.077.016 7.978.666 8 1.911 8 .637 8.903.016 10.514.001L10.572 0h4.388c.563 0 1.022.454 1.04 1.02V11.822c0 .57-.447 1.036-1.006 1.054h-4.422c-.868 0-1.53.198-1.952.56l-.034.03-.307.28c-.158.144-.4.144-.558 0l-.307-.28h0z",
    transform: "translate(26.5 29)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8 1.911L8 9",
    transform: "translate(26.5 29)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegisteredUser);
export default __webpack_public_path__ + "static/media/icon-registered-user.48c1328f.svg";
export { ForwardRef as ReactComponent };